import React from 'react';
import SelectionList from '../../../shared/components/SelectionList';
import _ from 'lodash';

/**
 * @typedef {object} PracticeAreaSelectionProps
 * @property {Array<*>} [practiceAreaList]
 * @property {Object} [practiceArea]
 * @property {(practiceArea: { label: string, value: number | string } | Array<{ label: string, value: number | string }> | null) => void} [setPracticeArea]
 * @property {boolean} [loading]
 */

/**
 * @param {PracticeAreaSelectionProps} props
 */
const PracticeAreaSelection = props => {
  const { practiceArea, setPracticeArea, loading, practiceAreaList = [] } = props;

  const practiceAreaOptions = _(practiceAreaList)
    .map(pa => ({
      label: pa.Name,
      value: pa.InternalId
    }))
    .orderBy(pa => pa.label)
    .value();

  return (
    <div className='appraisal-view-customization__section'>
      <SelectionList
        key={practiceArea}
        id='select-practice-area'
        label='Practice Area'
        onSelectHandler={setPracticeArea}
        selectedValue={practiceArea}
        list={practiceAreaOptions}
        required
        placeholder='Select a Practice Area'
        loading={loading}
      />
    </div>
  );
};

export default PracticeAreaSelection;
